<div class="tn-advertisement">
  <div class="ad-image-wrapper">
    <img #adImage [src]="adImageSrc" (click)="onAdClick()" (keypress)="onAdClick()" (load)="afterImageLoaded()" alt="advertisement">
    <div class="ad-image-close-wrapper" (click)="close()">
      <div class="btn-close"></div>
    </div>
  </div>
</div>